<template>
  <div>
    <Row>
      <Col span="16">商城首页热销抬头图片</Col>
      <Col span="8">
        <Upload
          name="filename"
          :show-upload-list="false"
          :action="uploadhost"
          :format="['jpg','jpeg','png']"
          :on-success="fn_uploadSuccess"
          :max-size="2048"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          style="display: inline-block;width:90px;"
        >
          <Button icon="ios-cloud-upload-outline">上传图片</Button>
        </Upload>
      </Col>
    </Row>
    <Row class="p-b-10">
      <Col span="24">
        <img :src="logourl+hotsalesimg" style="max-height:100px" />
      </Col>
    </Row>
    <hr />
    <Row class="p-t-10">
      <Col span="16">商城首页热销抬头图片高度</Col>
      <Col span="8">
        <InputNumber style="width:100%" v-model="hotsalesimgHeight" />
      </Col>
    </Row>
    <Row class="p-t-10">
      <Col span="16">&nbsp</Col>
      <Col span="8">
        <Button type="primary" @click="fn_save_imgHegith">保存</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import config from "@/config";
import { getEnumByCode, saveEnumData } from "@/api/config";
export default {
  data() {
    return {
      logourl: config.baseUrl.imageurl,
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      hotsalesimg: "",
      hotsalesimgHeight: 200,
      enumcode: "homeHotSaleTitleImg",
      enumcodeHeight: "homeHotSaleTitleImgHeight"
    };
  },
  mounted() {
    getEnumByCode(this.enumcode + "," + this.enumcodeHeight)
      .then(res => {
        this.hotsalesimg = res.data.homeHotSaleTitleImg.value;
        this.hotsalesimgHeight = parseFloat(
          res.data.homeHotSaleTitleImgHeight.value
        );
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  methods: {
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.hotsalesimg = file.response.data;
        saveEnumData({
          code: this.enumcode,
          value: this.hotsalesimg,
          remarks: "首页热销抬头图片文件"
        })
          .then(res => {
            if (res.data.code == 200) {
              this.$Notice.success(res.data);
            } else {
              this.$Notice.error(res.data);
            }
          })
          .catch(error => {
            this.$Message.error(error);
          });
      }
    },
    fn_save_imgHegith() {
      saveEnumData({
        code: this.enumcodeHeight,
        value: this.hotsalesimgHeight,
        remarks: "首页热销抬头图片文件高度"
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 2M。"
      });
    }
  }
};
</script>